import { render } from "./PayPass.vue?vue&type=template&id=1bb3cf58"
import script from "./PayPass.vue?vue&type=script&lang=js"
export * from "./PayPass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__